import { apiFetch } from "../api.js";
import type {
  CreateTradeEntryInput,
  TradeEntriesListResponse,
  TradeEntry,
  UpdateTradeEntryInput,
} from "./types.js";

/**
 * Trade-journal API module — household-scoped CRUD shipped in Phase 2
 * Session 2.4. All `*_price_cents` fields are integer cents; the SPA
 * converts dollars→cents at the form edge via `dollarsToCents()`.
 *
 * Closed P&L is computed server-side at read time and surfaced as
 * `closed_pnl_cents` on each entry (null while open).
 */

export function listTradeEntries(): Promise<TradeEntriesListResponse> {
  return apiFetch<TradeEntriesListResponse>("/v1/trade-journal");
}

export function getTradeEntry(entryId: string): Promise<TradeEntry> {
  return apiFetch<TradeEntry>(
    `/v1/trade-journal/${encodeURIComponent(entryId)}`,
  );
}

export function createTradeEntry(
  input: CreateTradeEntryInput,
): Promise<TradeEntry> {
  return apiFetch<TradeEntry>("/v1/trade-journal", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateTradeEntry(
  entryId: string,
  input: UpdateTradeEntryInput,
): Promise<TradeEntry> {
  return apiFetch<TradeEntry>(
    `/v1/trade-journal/${encodeURIComponent(entryId)}`,
    {
      method: "PATCH",
      body: JSON.stringify(input),
    },
  );
}

export function deleteTradeEntry(entryId: string): Promise<void> {
  return apiFetch<void>(
    `/v1/trade-journal/${encodeURIComponent(entryId)}`,
    { method: "DELETE" },
  );
}
